<div class="confirm" [ngClass]="{ 'img-component': data.img }">
	<img *ngIf="data.img" [src]="data.img" alt="" />
	<h2>{{ data.title }}</h2>
	<p>{{ data.msg }}</p>
	<div class="btn-grp centered">
		<button (click)="onCloseDialog(true)" class="app-btn primary">{{ data.acceptButton || 'Aceptar' }}</button>
		<button (click)="onCloseDialog(false)" class="app-btn optional">{{ data.declineButton || 'Cancelar' }}</button>
	</div>
</div>